import { post,get } from "./http";
import common from './constants';
let basic = common.interfacePath.serverTestUrl;

export const matchApi = {
	
	listMatchTrade: (params) => {
		return post(`/matchTrade/listMatchTrade`, params);
	},// 现货列表筛选
  listMatchOrder: (params) => {
    return post(`/matchTrade/listMatchOrder`, params);
  },//查询买单信息
	// getMatchActivity: getFn(`/matchTrade/getMatchActivity`), 
  getMatchActivity: (params) => {
    return get(`/matchTrade/getMatchActivity`, params);
  },//获取现货详情


  getResourceTypesList: (params) => {
    return post(`/auction/getResourceTypesList`, params);
  },  //前台搜索分类
  listAuctionToBegin: (params) => {
    return post(`/auction/listAuctionToBegin`, params);
  },  //竞拍大厅 - 即将开始
  listAuctionInProgress: (params) => {
    return post(`/auction/listAuctionInProgress`, params);
  },  //竞拍大厅 - 正在竞拍
  listAuctionCompleted: (params) => {
    return post(`/auction/listAuctionCompleted`, params);
  },  //竞拍大厅 - 已结束
  listAuctionMyIntent: (params) => {
    return post(`/auction/listAuctionMyIntent`, params);
  },  //竞拍大厅 - 我参与的
  listNotice: (params) => {
    return post(`/auction/listNotice`, params);
  },  //通知公告列表
  listDiscussResult: (params) => {
    return post(`/auction/listDiscussResult`, params);
  },  //结果公告
  saveAuctionDiscuss: (params) => {
    return post(`/auction/saveAuctionDiscuss`, params);
  },  //出价
  saveIntentNoPay: (params) => {
    return post(`/auction/saveIntentNoPay`, params);
  },  //参与
  saveIntentWithPay: (params) => {
    return post(`/auction/saveIntentWithPay`, params);
  },  //缴纳保证金
  queryKlbEscrowAgreement: (params) => {
    return post(`${basic}/payment/queryKlbEscrowAgreement`, params);
  },  //查询签约状态
  signKlbEscrowAgreement: (params) => {
    return post(`${basic}/payment/signKlbEscrowAgreement`, params);
  }, //签订昆仑银行
  cancelKlbEscrowAgreement: (params) => {
    return post(`${basic}/payment/cancelKlbEscrowAgreement`, params);
  }, //签订昆仑银行

};
